import React from 'react'
import { Link } from 'react-router-dom'

import Preference from './Preference'
import RestrictedComponent from '../../lib/components/form/RestrictedComponent'
import schema from '../../routes/permissions/schema'

const PlayerManager = (props) => {
  if (!props.preferences.length)
    return (
      <div className='alert alert-info'>
        <h4>No Player Preferences Available.</h4>
        <p>
          <em>
            <RestrictedComponent
              permissionCheck={schema.MANAGE_CLIENT_PLAYER_SETTINGS.CREATE}
            >
              <Link to='/manage/player/edit'>Create one here &hellip;</Link>
            </RestrictedComponent>
          </em>
        </p>
      </div>
    )

  const { preferences, actions, credentials, search } = props

  const matchesSearchFilter = (preference) => {
    if (!search) return true
    const prefName = preference.playerPref.name
    return (
      prefName.toLowerCase().includes(search.toLowerCase()) ||
      search.toLowerCase().includes(prefName.toLowerCase())
    )
  }

  return (
    <div>
      {preferences.filter(matchesSearchFilter).map(function (pref) {
        const { prefID, playerPref } = pref
        return (
          <Preference
            key={'player-preference-' + prefID}
            preferenceID={prefID}
            isDefault={pref.default}
            preference={playerPref}
            actions={actions}
            credentials={credentials}
          />
        )
      }, this)}
    </div>
  )
}

export default PlayerManager
